import React, { Component } from 'react';
// import videoIcon from 'assets/img/file_video.png';
import PropTypes from 'prop-types';
import { Player, ControlBar } from 'video-react';
import 'video-react/dist/video-react.css';
class PreviewVideoWO extends Component {
    static propTypes = {
      data: PropTypes.string,
      loading: PropTypes.bool,
      showDialog: PropTypes.bool,
      handleCloseVideo: PropTypes.func
    };
    constructor(props) {
      super(props);
      this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      this.state = {
        thumbnailWidth: 0,
        videoThumbnailWidth: 0,
        showDialog: false,
        player: {
          paused: true,
          videoHeight: 0,
          videoWidth: 0
        }
      };
    }

    componentDidMount() {
      // subscribe state change
      if (this.refs.player) {
        this.refs.player.subscribeToStateChange(this.handleStateChange);
      }
    }

    handleStateChange = (state, prevState) => {
      if (
        state.paused !== prevState.paused ||
          state.isFullscreen !== prevState.isFullscreen
      ) {
        this.setState({ player: state }, () => {
          if (this.isMobile) {
            if (!state.isFullscreen && !prevState.paused) {
              this.refs.player.pause();
            }
          } else {
            if (!state.paused && !this.state.showDialog) {
              this.setState({ showDialog: true, player: state }, () => {
                this.onToggleBodyScroll(false);
              });
            }
          }
        });
      }
    };

      onToggleBodyScroll = allowed => {
        if (allowed) {
          //allowed === true then allow body scroll
          document
            .getElementsByTagName('BODY')[0]
            .classList.remove('body-not-scroll');
        } else {
          //allowed === false then prevent body scroll
          document.getElementsByTagName('BODY')[0].classList.add('body-not-scroll');
        }
      };

      onCloseVideoDialog = () => {
        this.props.handleCloseVideo(() => {
        // this.refs.player.pause();
          this.onToggleBodyScroll(true);
        });
      };

      render() {
        const { data, showDialog} = this.props;

        const { player } = this.state;

        const { videoHeight, videoWidth } = player;

        const dialogClassName = showDialog
          ? 'project-video-dialog'
          : 'project-video-item-wrapper';

        const videoItemClassName = showDialog
          ? 'project-video-playing-item'
          : 'project-video-item thumbnail-wrapper-item';

        const videoRatio = videoWidth / videoHeight;

        const videoPlayingItemHeight = window.innerHeight * 0.8;

        const videoPlayingItemWidth = videoPlayingItemHeight * videoRatio;

        let videoItemStyle = !showDialog
          ? { height: 150 }
          : { height: videoPlayingItemHeight, width: videoPlayingItemWidth };

        const disableControlBar =
          !player ||
          (!this.isMobile && !showDialog) ||
          (this.isMobile && !player.isFullscreen);
        return (
          <div className={dialogClassName}>
            {showDialog && (
              <React.Fragment>
                <div className='project-video-fade' />
                <i
                  className='fa fa-close close-video-btn'
                  onClick={this.onCloseVideoDialog}
                />
              </React.Fragment>
            )}
            <div className={videoItemClassName} style={videoItemStyle}>
              <Player
                ref='player'
                fluid={false}
                height='100%'
                preload='metadata'
                autoPlay={true}
              >
                <source src={data} />
                <ControlBar disableCompletely={disableControlBar} />
              </Player>
              <div className='document-fade' />
            </div>
          </div>
        );
      }
}

export default PreviewVideoWO;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/PreviewVideoWO.js